module.exports = __webpack_public_path__ + "static/media/juliana.73bba884.jpg";